<template>
	<div class="request-password-reset-page">
		<p class="text-color--light-grey request-reset-password-page__instructions">Please enter your email to request a password reset.</p>
		<form @submit.prevent="onSubmit">
			<div class="form-group">
				<input class="text-input input--primary font-size--medium" type="email" placeholder="Email" v-model="email" required>
			</div>
			<div class="form-group">
				<input class="btn btn--form-submit font-size--medium" type="submit" value="Send Reset Email">
			</div>
		</form>

		<div class="popup--successful" v-if="showSuccessful">
			<div class="popup--successful__content">
				<p>If the account exists, an email will arrive shortly with a link to reset the password.</p>
				<button class="font-size--medium text-color--secondary" @click="closeSuccesful">Close</button>
			</div>
		</div>

		<errors :errorMessages="errorMessages" :header="errorMessage" v-if="errorMessages.length > 0"></errors>
	</div>
</template>

<script>
	import axios from '../axios'
	import { mapGetters, mapMutations } from 'vuex'
	import Errors from '../components/ErrorMessages'

	export default {
		components: {
			'errors': Errors,
		},
		data() {
			return {
				email: '',
				showSuccessful: false,
				errorMessage: 'Please fix the following errors'
			}
		},
		computed: {
			...mapGetters([
				'authToken',
				'errorMessages'
			])
		},
		methods: {
			...mapMutations([
				'httpInProgress',
				'httpFinished',
				'setErrorMessages'
			]),
			onSubmit() {
				const token = this.authToken
				const headers = { Authorization: 'Bearer '.concat(token) }
				var data = {
					email: this.email
				}
				this.httpInProgress()
				axios.post('request-reset-password', data, { headers })
					.then(response => {
						this.showSuccessful = true
						this.setErrorMessages([])
						this.httpFinished()
						return response
					}).catch(error => {
						if('error' in error.response.data) {
							this.setErrorMessages(['That current password is incorrect.'])
						} else {
							var errors = []
							for(var key in error.response.data.errors) {
								var element = error.response.data.errors[key]
								for (let prop in element) {
									errors.push(element[prop])
								}
							}
							this.setErrorMessages(errors)
						}
						this.httpFinished()
					})	
			},
			closeSuccesful() {
				this.$router.replace('/login')
			}
		},
		destroyed() {
			this.setErrorMessages([])
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/requestPasswordReset';
</style>